<template>
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle">
      <div class="auth-box ">
        <div class="left">
          <div class="content">
            <div class="logo text-center"><img src="../assets/img/logo.png" alt="VDCI Logo"></div>
            <form class="form-auth-small" @submit.prevent="onSubmit">
              <div class="form-group">
                <label for="email" class="control-label sr-only">Email</label>
                <input type="email" class="form-control" id="email" v-model="user.email" placeholder="Email" required autofocus>
              </div>

              <div class="input-group">
                <label for="password" class="control-label sr-only">Password</label>
                <input type="password" class="form-control" id="password" v-model="user.password" placeholder="password" required>
                <span class="input-group-addon"><i class="fa fa-info" data-toggle="tooltip" data-placement="bottom" title="Your password must contain at least 8 characters; including at least one upper case, one lower case, one number and one special character."></i></span>
              </div>

              <div class="form-group">
                <label for="passwordConfirmation" class="control-label sr-only">Password</label>
                <input type="password" class="form-control" id="passwordConfirmation" v-model="user.passwordConfirmation" placeholder="confirm password" required>
              </div>

              <loading-button :loading="loading" class="btn btn-primary btn-lg btn-block">Reset Password</loading-button>
              <div class="bottom">
                <span><i class="fa fa-lock"></i> <router-link :to="{name: 'login'}">Login</router-link></span>
              </div>
            </form>
          </div>
        </div>
        <div class="right">
          <div class="overlay"></div>
          <div class="content text">
            <h1 class="heading">Vector Disease Control International</h1>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import AuthService from '../services/AuthService';
  import LoadingButton from '@/components/loading-button';

  export default {
    name: 'forgotPassword',

    components: {
      LoadingButton
    },

    data() {
      return {
        loading: false,
        user: {
          email: '',
          password: '',
          passwordConfirmation: ''
        }
      }
    },

    mounted() {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },

    methods: {
      onSubmit() {
        this.loading = true;
        AuthService.resetPassword(this.user, this.$route.query.token,)
          .then(() => {
            toastr.success('Your password has been reset.');
            this.data.email = '';
            this.data.password = '';
            this.data.passwordConfirmation = '';
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            toastr.error(error);
          })
      }
    }
  }
</script>

<style lang="scss">
  .input-group {
    margin-bottom: 15px;
  }
</style>